/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowServerWeb = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
exports.WorkflowServerWeb = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        CardsService: function () {
            return function (headers) {
                var service = {
                    archiveCard: function (archiveCardRequest) {
                        return httpClient.invoke('POST', '/api/v1/cards/{id}/archive', archiveCardRequest, headers);
                    },
                    createCard: function (createCardRequest) {
                        return httpClient.invoke('POST', '/api/v1/workflows/{workflow_id}/phases/{phase_id}/cards', createCardRequest, headers);
                    },
                    deleteCard: function (deleteCardRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/cards/{id}', deleteCardRequest, headers);
                    },
                    getCard: function (getCardRequest) {
                        return httpClient.invoke('GET', '/api/v1/cards/{id}', getCardRequest, headers);
                    },
                    listCards: function (listCardsRequest) {
                        return httpClient.invoke('GET', '/api/v1/workflows/{workflow_id}/cards', listCardsRequest, headers);
                    },
                    moveCard: function (moveCardRequest) {
                        return httpClient.invoke('POST', '/api/v1/cards/{id}/move', moveCardRequest, headers);
                    },
                    queryCards: function (queryCardsRequest) {
                        return httpClient.invoke('POST', '/api/v1/cards/query', queryCardsRequest, headers);
                    },
                    restoreCard: function (restoreCardRequest) {
                        return httpClient.invoke('POST', '/api/v1/cards/{id}/restore', restoreCardRequest, headers);
                    },
                    updateCard: function (updateCardRequest) {
                        return httpClient.invoke('PATCH', '/api/v1/cards/{id}', updateCardRequest, headers);
                    }
                };
                service.archiveCard.__http_method = 'POST';
                service.archiveCard.__http_url = '/api/v1/cards/{id}/archive';
                service.createCard.__http_method = 'POST';
                service.createCard.__http_url = '/api/v1/workflows/{workflow_id}/phases/{phase_id}/cards';
                service.deleteCard.__http_method = 'DELETE';
                service.deleteCard.__http_url = '/api/v1/cards/{id}';
                service.getCard.__http_method = 'GET';
                service.getCard.__http_url = '/api/v1/cards/{id}';
                service.listCards.__http_method = 'GET';
                service.listCards.__http_url = '/api/v1/workflows/{workflow_id}/cards';
                service.moveCard.__http_method = 'POST';
                service.moveCard.__http_url = '/api/v1/cards/{id}/move';
                service.queryCards.__http_method = 'POST';
                service.queryCards.__http_url = '/api/v1/cards/query';
                service.restoreCard.__http_method = 'POST';
                service.restoreCard.__http_url = '/api/v1/cards/{id}/restore';
                service.updateCard.__http_method = 'PATCH';
                service.updateCard.__http_url = '/api/v1/cards/{id}';
                return service;
            };
        },
        PhasesService: function () {
            return function (headers) {
                var service = {
                    createPhase: function (createPhaseRequest) {
                        return httpClient.invoke('POST', '/api/v1/workflows/{workflow_id}/phases', createPhaseRequest, headers);
                    },
                    deletePhase: function (deletePhaseRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/phases/{id}', deletePhaseRequest, headers);
                    },
                    getPhase: function (getPhaseRequest) {
                        return httpClient.invoke('GET', '/api/v1/phases/{id}', getPhaseRequest, headers);
                    },
                    listPhases: function (listPhasesRequest) {
                        return httpClient.invoke('GET', '/api/v1/workflows/{workflow_id}/phases', listPhasesRequest, headers);
                    },
                    movePhase: function (movePhaseRequest) {
                        return httpClient.invoke('POST', '/api/v1/workflows/{workflow_id}/phases/{id}/move', movePhaseRequest, headers);
                    },
                    queryPhases: function (queryPhasesRequest) {
                        return httpClient.invoke('POST', '/api/v1/phases/query', queryPhasesRequest, headers);
                    },
                    updatePhase: function (updatePhaseRequest) {
                        return httpClient.invoke('PATCH', '/api/v1/phases/{id}', updatePhaseRequest, headers);
                    }
                };
                service.createPhase.__http_method = 'POST';
                service.createPhase.__http_url = '/api/v1/workflows/{workflow_id}/phases';
                service.deletePhase.__http_method = 'DELETE';
                service.deletePhase.__http_url = '/api/v1/phases/{id}';
                service.getPhase.__http_method = 'GET';
                service.getPhase.__http_url = '/api/v1/phases/{id}';
                service.listPhases.__http_method = 'GET';
                service.listPhases.__http_url = '/api/v1/workflows/{workflow_id}/phases';
                service.movePhase.__http_method = 'POST';
                service.movePhase.__http_url = '/api/v1/workflows/{workflow_id}/phases/{id}/move';
                service.queryPhases.__http_method = 'POST';
                service.queryPhases.__http_url = '/api/v1/phases/query';
                service.updatePhase.__http_method = 'PATCH';
                service.updatePhase.__http_url = '/api/v1/phases/{id}';
                return service;
            };
        },
        TemplatesService: function () {
            return function (headers) {
                var service = {
                    cloneTemplate: function (cloneTemplateRequest) {
                        return httpClient.invoke('POST', '/api/v1/templates/{id}/clone', cloneTemplateRequest, headers);
                    },
                    getTemplate: function (getTemplateRequest) {
                        return httpClient.invoke('GET', '/api/v1/templates/{id}', getTemplateRequest, headers);
                    },
                    listTemplates: function (listTemplatesRequest) {
                        return httpClient.invoke('GET', '/api/v1/templates', listTemplatesRequest, headers);
                    }
                };
                service.cloneTemplate.__http_method = 'POST';
                service.cloneTemplate.__http_url = '/api/v1/templates/{id}/clone';
                service.getTemplate.__http_method = 'GET';
                service.getTemplate.__http_url = '/api/v1/templates/{id}';
                service.listTemplates.__http_method = 'GET';
                service.listTemplates.__http_url = '/api/v1/templates';
                return service;
            };
        },
        WorkflowsService: function () {
            return function (headers) {
                var service = {
                    createWorkflow: function (createWorkflowRequest) {
                        return httpClient.invoke('POST', '/api/v1/workflows', createWorkflowRequest, headers);
                    },
                    deleteWorkflow: function (deleteWorkflowRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/workflows/{id}', deleteWorkflowRequest, headers);
                    },
                    getWorkflow: function (getWorkflowRequest) {
                        return httpClient.invoke('GET', '/api/v1/workflows/{id}', getWorkflowRequest, headers);
                    },
                    listWorkflows: function (listWorkflowsRequest) {
                        return httpClient.invoke('GET', '/api/v1/workflows', listWorkflowsRequest, headers);
                    },
                    queryWorkflows: function (queryWorkflowsRequest) {
                        return httpClient.invoke('POST', '/api/v1/workflows/query', queryWorkflowsRequest, headers);
                    },
                    setupWorkflow: function (setupWorkflowRequest) {
                        return httpClient.invoke('POST', '/api/v1/workflows/setup', setupWorkflowRequest, headers);
                    },
                    updateWorkflow: function (updateWorkflowRequest) {
                        return httpClient.invoke('PATCH', '/api/v1/workflows/{id}', updateWorkflowRequest, headers);
                    }
                };
                service.createWorkflow.__http_method = 'POST';
                service.createWorkflow.__http_url = '/api/v1/workflows';
                service.deleteWorkflow.__http_method = 'DELETE';
                service.deleteWorkflow.__http_url = '/api/v1/workflows/{id}';
                service.getWorkflow.__http_method = 'GET';
                service.getWorkflow.__http_url = '/api/v1/workflows/{id}';
                service.listWorkflows.__http_method = 'GET';
                service.listWorkflows.__http_url = '/api/v1/workflows';
                service.queryWorkflows.__http_method = 'POST';
                service.queryWorkflows.__http_url = '/api/v1/workflows/query';
                service.setupWorkflow.__http_method = 'POST';
                service.setupWorkflow.__http_url = '/api/v1/workflows/setup';
                service.updateWorkflow.__http_method = 'PATCH';
                service.updateWorkflow.__http_url = '/api/v1/workflows/{id}';
                return service;
            };
        }
    };
};
exports.WorkflowServerWeb.__transport = 'http';
__exportStar(require("./types"), exports);
